import React from "react";
import { ContentContainer, Title } from "./Abonnement";
import { Alert, Collapse, Grid, Skeleton, Snackbar, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getUser, setUser } from "../store/reducers/authSlice";
import InexSwitch from "../components/InexSwitch";
import InexButton from "../components/InexButton";
import { useUpdateUserNewslettersMutation } from "../store/api/user";
import { setShowSnackbar, setSnackbarSeverity, setSnackbarText } from "../store/reducers/snackbarSlice";
import withAuth from "../HOC/withAuth";
import useTabTitle from "../hooks/useTabTitle";
import SmartsuppChat from "../components/SmartsuppChat";

const Newsletter = () => {
	const user = useSelector(getUser);
	useTabTitle({ customTitle: "Mes newsletters" });

	const reduceFunc = (state, action) => {
		return { ...state, [action.field]: action.value };
	};

	
	const [formValues, setFormValue] = React.useReducer(reduceFunc, {
		isActu: user?.newsletters?.actu === 1,
		isNotif: user?.newsletters?.notif === 1,
		isPromo: user?.newsletters?.promo === 1,
		isNotifPro: user?.newslettersPro?.notif === 1,
		isActuPro: user?.newslettersPro?.actu === 1,
	});

	React.useEffect(() => {
		setFormValue({ field: "isActu", value: user?.newsletters?.actu === 1 });
		setFormValue({ field: "isNotif", value: user?.newsletters?.notif === 1 });
		setFormValue({ field: "isPromo", value: user?.newsletters?.promo === 1 });
		setFormValue({ field: "isNotifPro", value: user?.newslettersPro?.notif === 1 });
		setFormValue({ field: "isActuPro", value: user?.newslettersPro?.actu === 1 });
	}, [user]);

	const [updateNewsletters] = useUpdateUserNewslettersMutation();
	const [isFetching, setIsFetching] = React.useState(false);

	const dispatch = useDispatch();
	const setShowSnackBar = () => {
		dispatch(setShowSnackbar(true));
		dispatch(setSnackbarSeverity("success"));
		dispatch(setSnackbarText("Vos informations ont bien été mises à jour."));
	};

	const saveUserInfoChanges = () => {
		setIsFetching(true);
		updateNewsletters({
			hasNotif: formValues.isNotif,
			hasPromo: formValues.isPromo,
			hasActu: formValues.isActu,
			hasActuPro: formValues.isActuPro,
			hasNotifPro: formValues.isNotifPro,
		}).then(({ data }) => {
			setIsFetching(false);
			const newsletters = {
				actu : +formValues.isActu, 
				notif: +formValues.isNotif, 
				promo: +formValues.isPromo
			}
			const newslettersPro = {
				actu : +formValues.isActuPro, 
				notif: +formValues.isNotifPro, 
			}
			if (data) {
				dispatch(setUser({...user, newsletters, newslettersPro}));
				setShowSnackBar();
			}
		});
	};

	return (
		<ContentContainer container item className={"content-background"}>
			<Grid
				item
				xs={12}
				sx={{
					marginBottom: (theme) => theme.spacing(2),
				}}
			>
				<Title>NOS NEWSLETTERS GRAND PUBLIC</Title>
			</Grid>
			<Grid container xs={12} spacing={3} mt={0}>
				<Grid item xs={12} display={"flex"} flexWrap={"nowrap"} alignItems={"center"}>
					{!user ? (
						<Skeleton
							width={"100%"}
							height={"30px"}
							sx={{
								backgroundColor: "white",
								boxShadow: (theme) => theme.shadows[25],
								borderRadius: "8px",
							}}
							variant="rectangular"
							animation={"pulse"}
						/>
					) : (
						<>
							<InexSwitch
								checked={formValues.isPromo}
								onClick={() => {
									setFormValue({ field: "isPromo", value: !formValues.isPromo });
								}}
							/>
							<Typography
								color={"secondary"}
								fontSize={20}
								sx={{
									fontFamily: "Branding SemiBold",
									marginLeft: (theme) => theme.spacing(3),
								}}
							>
								Recevoir nos offres commerciales
							</Typography>
						</>
					)}
				</Grid>
				<Grid item xs={12} display={"flex"} flexWrap={"nowrap"} alignItems={"center"}>
					{!user ? (
						<Skeleton
							width={"100%"}
							height={"30px"}
							sx={{
								backgroundColor: "white",
								boxShadow: (theme) => theme.shadows[25],
								borderRadius: "8px",
							}}
							variant="rectangular"
							animation={"pulse"}
						/>
					) : (
						<>
							<InexSwitch
								checked={formValues.isActu}
								onClick={() => {
									setFormValue({ field: "isActu", value: !formValues.isActu });
								}}
							/>
							<Typography
								color={"secondary"}
								fontSize={20}
								sx={{
									fontFamily: "Branding SemiBold",
									marginLeft: (theme) => theme.spacing(3),
								}}
							>
								Recevoir nos actualités gratuites
							</Typography>
						</>
					)}
				</Grid>
				
				<Grid item xs={12} display={"flex"} flexWrap={"nowrap"} alignItems={"center"}>
					{!user ? (
						<Skeleton
							width={"100%"}
							height={"30px"}
							sx={{
								backgroundColor: "white",
								boxShadow: (theme) => theme.shadows[25],
								borderRadius: "8px",
							}}
							variant="rectangular"
							animation={"pulse"}
						/>
					) : (
						<>
							<InexSwitch
								checked={formValues.isNotif}
								onClick={() => {
									setFormValue({ field: "isNotif", value: !formValues.isNotif });
								}}
							/>
							<Typography
								color={"secondary"}
								fontSize={20}
								sx={{
									fontFamily: "Branding SemiBold",
									marginLeft: (theme) => theme.spacing(3),
								}}
							>
								Recevoir les notifications liées à mes éventuels abonnement
								 ( sorties de magazines, nouvelles vidéos, fin d’abonnement... )
							</Typography>
						</>
					)}
				</Grid>
				
			</Grid>
			<Grid
				item
				xs={12}
				sx={{
					marginBottom: (theme) => theme.spacing(2),
					marginTop: (theme) => theme.spacing(4),
				}}
			>
				<Title>NOS NEWSLETTERS PROS </Title>
			</Grid>
			<Grid container xs={12} spacing={3} mt={0}>
				<Grid item xs={12} display={"flex"} flexWrap={"nowrap"} alignItems={"center"}>
					{!user ? (
						<Skeleton
							width={"100%"}
							height={"30px"}
							sx={{
								backgroundColor: "white",
								boxShadow: (theme) => theme.shadows[25],
								borderRadius: "8px",
							}}
							variant="rectangular"
							animation={"pulse"}
						/>
					) : (
						<>
							<InexSwitch
								checked={formValues.isActuPro}
								onClick={() => {
									setFormValue({ field: "isActuPro", value: !formValues.isActuPro });
								}}
							/>
							<Typography
								color={"secondary"}
								fontSize={20}
								sx={{
									fontFamily: "Branding SemiBold",
									marginLeft: (theme) => theme.spacing(3),
								}}
							>
								Recevoir les offres et actualités réservées aux praticiens
							</Typography>
						</>
					)}
				</Grid>
				<Grid item xs={12} display={"flex"} flexWrap={"nowrap"} alignItems={"center"}>
					{!user ? (
						<Skeleton
							width={"100%"}
							height={"30px"}
							sx={{
								backgroundColor: "white",
								boxShadow: (theme) => theme.shadows[25],
								borderRadius: "8px",
							}}
							variant="rectangular"
							animation={"pulse"}
						/>
					) : (
						<>
							<InexSwitch
								checked={formValues.isNotifPro}
								onClick={() => {
									setFormValue({ field: "isNotifPro", value: !formValues.isNotifPro });
								}}
							/>
							<Typography
								color={"secondary"}
								fontSize={20}
								sx={{
									fontFamily: "Branding SemiBold",
									marginLeft: (theme) => theme.spacing(3),
								}}
							>
								Recevoir les notifications liées à mon éventuel abonnement Praticien
								 ( nouvelles ressources, fin d’abonnement... )
							</Typography>
						</>
					)}
				</Grid>
				<Grid item xs={12} display={"flex"} flexWrap={"nowrap"} alignItems={"center"} mt={2}>
					{!user ? (
						<Skeleton
							width={"100%"}
							height={"60px"}
							sx={{
								backgroundColor: "white",
								boxShadow: (theme) => theme.shadows[25],
								borderRadius: "8px",
							}}
							variant="rectangular"
							animation={"pulse"}
						/>
					) : (
						<Typography
							color={"secondary"}
							fontSize={20}
							sx={{
								fontFamily: "Branding SemiBold",
							}}
						>
							Pour vous tenir informés des points d'évolutions importants (CGV, tarifs, conditions
							d'abonnement) nous vous enverrons une newsletter. Cette dernière étant une obligation
							légale, il n'est pas possible de s'en désabonner.
						</Typography>
					)}
				</Grid>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
				<Collapse
					in={
						user &&
						(!!user.newsletters.actu !== formValues.isActu ||
							!!user.newsletters.promo !== formValues.isPromo ||
							!!user.newsletters.notif !== formValues.isNotif ||
							!!user?.newslettersPro?.notif !== formValues.isNotifPro ||
							!!user?.newslettersPro?.actu !== formValues.isActuPro 
						)
					}
				>
					<InexButton
						text={"Sauvegarder mes modifications"}
						onClick={saveUserInfoChanges}
						loading={isFetching}
						sx={{
							width: "100%",
							height: "50px",
							marginTop: (theme) => theme.spacing(4),
						}}
					/>
				</Collapse>
			</Grid>
			{/* Intégration de Smartsupp */}
			<SmartsuppChat />
		</ContentContainer>
	);
};

export default withAuth(Newsletter);
